import React, { useContext } from "react";
import SectionHeader from "../../partials/SectionHeader";
import { DataContext } from "../../../data";
import ProjectTile from "../../partials/ProjectTile";
import { CodeIcon } from '@heroicons/react/solid';
import { useScrollReveal } from "../../../hooks/useScrollReveal";


export default function PersonalProjects() {
  const { home, personalProjects } = useContext(DataContext);
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="personalProjects" className="text-text-color body-font">
      <div className="container px-5 py-5 mx-auto text-center lg:px-40">
        <SectionHeader {...{ title: home.personalProjects.title, icon: <CodeIcon/>, 'description': home.personalProjects.description }} />
        <div ref={ref} className={`flex flex-wrap -m-4 scroll-reveal${isVisible ? ' visible' : ''}`}>
          {personalProjects.map((project) => (
            <ProjectTile key={`personal-${project.id}`}  {...project} />
          ))}
        </div>
      </div>
    </section>
  );
}
